import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MenuAreaDto, MenuConfigurationDto } from '@core/services/api-clients';
import { AsyncPipe } from '@angular/common';
import { WebResourceUriPipe } from '../../../../shared/utils/pipes/relative-to-webresource-base64uri.pipe';

@Component({
    selector: 'app-main-menu-logo',
    templateUrl: './main-menu-logo.component.html',
    styleUrls: ['./main-menu-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, WebResourceUriPipe]
})
export class MainMenuLogoComponent {
  readonly selectedMenuArea = input<MenuAreaDto>(undefined);
  readonly isWide = input<boolean>(false);
  readonly menuConfiguration = input<MenuConfigurationDto>(undefined);
}
